import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { routeStorefrontMediaInHtml } from '@/lib/media-url';
import type { RichHtmlBlock } from '../types';
import styles from './RichHtml.module.css';
interface RichHtmlProps {
  block: RichHtmlBlock;
  blockId: string;
}

/**
 * Escape hatch for truly bespoke fragments. The migrator MUST justify each use
 * via `block.reason`. Renders with `dangerouslySetInnerHTML` — the converter is
 * responsible for any sanitization upstream.
 */
export function RichHtml(t0) {
  const $ = _c(8);
  const {
    block,
    blockId
  } = t0;
  const t1 = block.reason;
  let t2;
  if ($[0] !== block.html) {
    t2 = routeStorefrontMediaInHtml(block.html);
    $[0] = block.html;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = {
      __html: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== block.reason || $[5] !== blockId || $[6] !== t3) {
    t4 = <div className={styles.wrapper} data-cms-block-id={blockId} data-cms-field="richHtml" data-richhtml-reason={t1} dangerouslySetInnerHTML={t3} />;
    $[4] = block.reason;
    $[5] = blockId;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}